import { FC } from 'react';
import styled from '@emotion/styled';
import { Heading } from '../components';
import { PrimaryButton } from '../buttons';
import ErrorSvg from 'images/shared/server-error.svg';

interface Props {
  header?: string,
  buttonText?: string,
  onClickHandler?: () => void,
}

const BrokenContainer = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: 100%;
    
    svg {
        display: block;
        width: 100px;
        fill: ${({ theme }) => theme.primaryColor};
        
        .server-error_svg__warning-sign { fill: ${({ theme }) => theme.highlightColor}; }
    }
    
    ${Heading} {
        margin: 24px 0;
    }
    
    span {
        margin-top: 24px;
        color: ${({ theme }) => theme.primaryFontColor};
        font-size: 14px;
        letter-spacing: -0.1px;
    }    
`;

const InternalServerError: FC<Props> = ({
  header = 'Er is iets mis gegaan tijdens het berekenen',
  buttonText = 'Herlaad de tool',
  onClickHandler = () => window.location.reload()
}) => (
  <BrokenContainer>
    <ErrorSvg className="error" />
    <Heading>{header}</Heading>
    <PrimaryButton size="big" onClick={onClickHandler}>{buttonText}</PrimaryButton>
    <span>Of probeer het later opnieuw</span>
  </BrokenContainer>
);

export default InternalServerError;
